import React, { useEffect, useState, MouseEvent } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { debounce } from 'lodash';
import { useCurrentRefinements, useDynamicWidgets, useClearRefinements } from 'react-instantsearch';
import {
  formatDealsFacetDisplayLabel,
  isDealsFacetAttribute,
  isSortTransitionInProgress,
} from '@/helpers/utils/dealsFacetUtils';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { useProductListingContext } from './context/productListingContext';
import Close from '../../../../svgs/close';

const debounceReload = debounce(() => {
  // window.location.reload();
}, 500);

export function titleCase(string: string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

function CustomClearRefinements(props: any) {
  const { refine } = useClearRefinements(props);
  const router = useRouter();
  const handleClearRef = () => {
    refine();
    const url = new URL(window.location.href.split('/_/')[0]);
    url.searchParams.delete('facet');
    router.push(url?.toString(), {});
    window.history.pushState({}, '', url?.toString());
  };
  return (
    <button className="text-xs leading-[16.8px] text-black underline" onClick={handleClearRef}>
      {mapLocaleToMeaningfulFormat().removeAll}
    </button>
  );
}

const shouldReload = (categoryHit: any, currentURL: string) => {
  const getUrlFacets = new URLSearchParams(window.location.search).get('facet');
  if (categoryHit?.custom?.fields?.is_clp_page) {
    if (getUrlFacets && getUrlFacets?.indexOf('clearance') != -1) {
      return;
    }
    window.history.pushState({}, '', currentURL);
  }
};
export function CustomCurrentRefinements() {
  return <CurrentRefinementComponent />;
}
export function CurrentRefinementComponent() {
  const { items, refine } = useCurrentRefinements();
  const { refine: refineAll } = useClearRefinements();

  const router = useRouter();
  const { categoryHit, searchQuery, facets, pageType, setAppliedFilters } = useProductListingContext();
  const params = useSearchParams();
  const filters = params.get('facet');
  let parsedFacets = {};
  try {
    if (typeof facets === 'string') {
      parsedFacets = JSON.parse(facets);
    }
  } catch (e) {
    console.error('Error parsing facet JSON');
    parsedFacets = facets;
  }
  const facetEntries: [string, string][] = parsedFacets ? Object.entries(parsedFacets) : [];
  const [urlState, setUrlState] = useState(window.location.href);
  const { attributesToRender } = useDynamicWidgets();
  const [showClearance, setShowClearance] = useState(true);

  useEffect(() => {
    const url = new URL(window.location.href);
    const filters = url.searchParams.get('facet');
    if (filters) {
      const facets = filters.split('|');
      const clearanceEntry = facets.find((entry) => entry.startsWith('clearance:'));
      if (clearanceEntry) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, value] = clearanceEntry.split(':');
        if (value === 'false') {
          setShowClearance(false);
        } else {
          setShowClearance(true);
        }
      } else {
        setShowClearance(true);
      }
    }
  }, [items]);

  let timeoutId: any;
  function debounceRouterPush(url: any) {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      window.history.pushState({}, '', url);
      // window.location.reload();
    }, 1);
  }
  function removeRefinement(data: any, attributeToRemove: any, valueToRemove: any) {
    return data
      .map((item: any) => {
        if (item.attribute === attributeToRemove) {
          item.refinements = item.refinements.filter((refinement: any) => refinement.value !== valueToRemove);
        }
        return item;
      })
      .filter((item: any) => item.refinements.length > 0); // Remove attribute if refinements are empty
  }

  const handleRefineClick = (refinement: any) => {
    const filteredRefinements = removeRefinement(items, refinement.attribute, refinement.value);
    if (typeof window !== 'undefined') {
      const pageLoadFacets = sessionStorage.getItem('pageLoadFacets') ?? '';
      const facets = pageLoadFacets.split('|');
      const keys = facets.map((facet) => facet.split(':')[0]).filter((key) => !attributesToRender.includes(key));
      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('facet') && keys?.length === 0) {
        sessionStorage.removeItem('pageLoadFacets');
        sessionStorage.removeItem('isPageLoadFacetChecked');
      }
    }

    if (filteredRefinements && filteredRefinements.length == 0) {
      refine(refinement);
      refineAll();
      sessionStorage.removeItem('pageLoadFacets');
      const url = new URL(window.location.href.split('/_/')[0]);
      url.searchParams.delete('facet');
      router.push(url?.toString(), {});
      window.history.pushState({}, '', url?.toString());
      debounceReload();
    } else {
      refine(refinement);
    }
  };

  useEffect(() => {
    const pageLoadFacets = sessionStorage.getItem('pageLoadFacets') ?? '';
    const facets = pageLoadFacets.split('|');
    const keys = facets.map((facet) => facet.split(':')[0]).filter((key) => !attributesToRender.includes(key));

    if (items?.length === 0) {
      if (isSortTransitionInProgress() || !attributesToRender?.length) {
        return;
      }
      const currentUrl = new URL(window.location.href);
      if (typeof window !== 'undefined') {
        if (currentUrl.searchParams.has('facet') && keys?.length === 0) {
          sessionStorage.removeItem('pageLoadFacets');
          sessionStorage.removeItem('isPageLoadFacetChecked');
          currentUrl.searchParams.delete('facet');
          if (currentUrl?.pathname?.includes('_/')) {
            try {
              currentUrl.pathname = currentUrl?.pathname.split('_/')[0];
              currentUrl.href = currentUrl?.href.split('_/')[0];
            } catch (error) {}
          }
          const isSearchPageReload = sessionStorage?.getItem('isSearchPageReload') ?? '0';
          if (isSearchPageReload === '1') {
          } else {
            sessionStorage.removeItem('isSearchPageReload');
          }
        }
      }
    }
  }, [items]);

  useEffect(() => {
    const currentUrl = window.location.href;
    const currentFacet = new URLSearchParams(window.location.search).get('facet');

    if (urlState !== currentUrl) {
      const previousFacet = new URLSearchParams(new URL(urlState).search).get('facet');

      if (currentFacet !== previousFacet) {
        setUrlState(currentUrl);
        shouldReload(categoryHit, currentUrl);
        pageRefreshWorker(currentUrl?.toString());
      }
    }
  }, []);

  useEffect(() => {
    if (searchQuery && !filters) {
      items.forEach((item: any) => {
        item.refinements.forEach((refinement: any) => {
          refine(refinement);
        });
      });
    }
  }, [searchQuery]);

  useEffect(() => {
    const filtersSelected: { name: string | undefined; value: string }[] = [];
    setAppliedFilters(items);
    items.forEach((item: any) => {
      item.refinements.forEach((refinement: any) => {
        filtersSelected.push({
          name: facetEntries.find(([key]) => key === refinement?.attribute)?.[1],
          value: refinement?.value,
        });
      });
    });

    const counts = { Size: 0, Width: 0 };
    const tempArray: { type: string; item: { name: string | undefined; value: string } }[] = [];
    const filteredArray: { name: string | undefined; value: string }[] = [];

    filtersSelected?.forEach((obj) => {
      if (obj?.name) {
        if (obj?.name?.indexOf('Size') > -1) {
          counts.Size++;
          tempArray.push({ type: 'Size', item: obj });
        } else if (obj?.name?.indexOf('Width') > -1) {
          counts.Width++;
          tempArray.push({ type: 'Width', item: obj });
        }
      }
    });
    tempArray?.forEach(({ type, item }) => {
      if (type === 'Size' && counts?.Size === 1) {
        filteredArray?.push({ name: 'Size', value: item.value });
      }
      if (type === 'Width' && counts?.Width === 1) {
        filteredArray?.push({ name: 'Width', value: item.value });
      }
    });
    if (filteredArray?.length !== 0) {
      sessionStorage.setItem('filtersSelected', JSON.stringify(filteredArray));
    } else {
      sessionStorage.removeItem('filtersSelected');
    }
  }, [items, setAppliedFilters, facetEntries]);
  const filteredData = !showClearance ? items.filter((item) => item.attribute !== 'clearance') : items;

  function checkKeyExists(facets: string[], value: string): boolean {
    return facets.some((facet) => value.includes(facet));
  }
  const pageRefreshWorker = (currentUrl: string) => {
    if (typeof window !== 'undefined') {
      const isSearchPageReload = sessionStorage?.getItem('isSearchPageReload') ?? '0';
      if (pageType === 'search' && isSearchPageReload === '1') {
        sessionStorage.removeItem('isSearchPageReload');
        debounceRouterPush(currentUrl);
      } else {
        const defaultFacets: any = ['gender', 'colorRefinement', 'brandName', 'refinementStyle', 'refinementSubDept'];
        const keyExists = checkKeyExists(defaultFacets, currentUrl);
        if (pageType) {
          if (isSearchPageReload === '1' && !keyExists && ['plp', 'clp', 'brands'].includes(pageType)) {
            sessionStorage.removeItem('isSearchPageReload');
            debounceRouterPush(currentUrl);
          }
        }
      }
    }
  };
  return (
    <section
      className={`${
        items[0]?.refinements.length >= 1 ? '-mx-4 border-b border-silverGray px-4 pb-4 lg:border-b-0' : ''
      } flex flex-wrap items-center gap-3 `}
    >
      {filteredData.map((item: any) => (
        <React.Fragment key={[item.indexName, item.label].join('/')}>
          {item.refinements.map((refinement: any) => (
            <section key={refinement.label}>
              <section className="flex h-8 items-center justify-between gap-3 rounded-md border border-foggyGray px-3 text-sm leading-[19.6px] text-black">
                {refinement.attribute === 'clearance'
                  ? titleCase(refinement.attribute)
                  : isDealsFacetAttribute(refinement.attribute)
                  ? formatDealsFacetDisplayLabel(refinement.label)
                  : refinement.label}
                <button
                  type="button"
                  aria-label={`Remove ${refinement.label} filter`}
                  onClick={(event) => {
                    if (isModifierClick(event)) return;
                    handleRefineClick(refinement);
                  }}
                >
                  <Close className="size-4" />
                </button>
              </section>
            </section>
          ))}
        </React.Fragment>
      ))}
      {filteredData[0]?.refinements.length > 1 || Object.entries(filteredData).length > 1 ? (
        <section>
          <div className="cursor-pointer text-xs leading-[16.8px] text-black underline">
            <CustomClearRefinements />
          </div>
        </section>
      ) : null}
    </section>
  );
}

function isModifierClick(event: MouseEvent) {
  return Boolean(event.button === 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}
